<div [formGroup]="form">
  <div class="pt-4 pb-2 px-6">
    <h2 class="text-2xl font-semibold">{{ data.projectName }}</h2>
    <h3 class="uppercase font-semibold text-xs">
      {{ "notification.title" | translate }}
    </h3>
  </div>

  <mat-dialog-content>
    <div class="overflow-x-auto">
      <table class="table w-full">
        <thead class="text-center">
          <tr class="border-0">
            <th colspan="3">
              {{ "notification.who" | translate }}
            </th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>{{ "notification.pilotUvc" | translate }}</th>
            <th>{{ "notification.pilotLineage" | translate }}</th>
            <th>
              {{ "notification.pilotProject" | translate }}
            </th>
            <th>
              {{ "notification.frequency" | translate }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody formArrayName="rows">
          @for (
            row of rows.controls;
            track row.get("id")!.value;
            let i = $index
          ) {
            <tr [formGroupName]="i" [class.border-0]="$last">
              @for (opt of whoOpts; track opt) {
                <td>
                  <input
                    type="checkbox"
                    class="checkbox checkbox-primary mr-3"
                    [checked]="row.get('who')?.value.includes(opt.value)"
                    (change)="onWhoChange(i, opt.value, $event)"
                  />
                </td>
              }

              <td class="min-w-52">
                <select
                  formControlName="when"
                  class="select select-bordered w-full select-sm max-w-xs bg-white"
                  (change)="handleWhenChange(i, $event)"
                >
                  <option disabled selected value="">
                    {{ "notification.frequency" | translate }}
                  </option>

                  @for (opt of frequencyOpts; track opt; let k = $index) {
                    <option
                      [value]="opt.value"
                      [disabled]="
                        opt.value !== 'custom' && isFrequencyUsed(opt.value, i)
                      "
                    >
                      {{ opt.label | translate }}
                    </option>
                  }
                </select>
              </td>

              <td class="min-w-20">
                <button
                  class="btn btn-ghost btn-sm text-red-500"
                  type="button"
                  (click)="removeRow(i, row)"
                >
                  ✕
                </button>
              </td>
            </tr>

            @if (row.get("when")?.value === "custom") {
              <tr [formGroupName]="i">
                <td colspan="5">
                  <div class="collapse collapse-arrow">
                    <input
                      type="checkbox"
                      [checked]="openRowIndex === i"
                      (change)="toggleCollapse(i, $event)"
                    />
                    <div
                      class="collapse-title text-left text-base underline font-medium"
                    >
                      Définir les options
                    </div>
                    <div class="collapse-content">
                      <div class="flex flex-row items-center gap-2">
                        <h3 class="label font-bold text-start w-24">
                          {{ "notification.what" | translate }}
                        </h3>

                        @for (opt of whatOpts; track opt) {
                          <label
                            class="form-control w-full max-w-xscursor-pointer label"
                          >
                            <span>{{ opt.label | translate }}</span>
                            <input
                              type="checkbox"
                              class="checkbox checkbox-primary"
                              [checked]="
                                row.get('what')?.value.includes(opt.value)
                              "
                              (change)="onWhatChange(i, opt.value, $event)"
                            />
                          </label>
                        }
                      </div>

                      <div class="flex flex-row items-start gap-2 mb-4">
                        <label class="form-control w-full max-w-xs">
                          <div class="label">
                            <span class="label-text">
                              {{ "notification.start" | translate }}</span
                            >
                          </div>
                          <input
                            type="date"
                            class="input input-sm input-bordered w-full bg-white max-w-xs"
                            formControlName="from"
                          />
                        </label>
                        <label class="form-control w-full max-w-xs">
                          <div class="label">
                            <span class="label-text">
                              {{ "notification.end" | translate }}</span
                            >
                          </div>
                          <input
                            type="date"
                            class="input input-sm input-bordered w-full bg-white max-w-xs"
                            formControlName="until"
                          />
                        </label>
                      </div>

                      <div class="flex flex-row items-center gap-2 mb-4">
                        <select
                          formControlName="frequency"
                          class="select select-bordered w-full select-sm max-w-xs bg-white"
                        >
                          <option disabled selected value="">
                            {{ "notification.periodicity" | translate }}
                          </option>

                          @for (
                            opt of periodicityOpts;
                            track opt;
                            let k = $index
                          ) {
                            <option [value]="opt.value">
                              {{ opt.label | translate }}
                            </option>
                          }
                        </select>
                        @if (rows.at(i).get("frequency")?.value === "monthly") {
                          <div
                            class="flex flew-row justify-center items-center"
                          >
                            <h3 class="label font-bold text-start">
                              {{ "notification.every" | translate }}
                            </h3>
                            <input
                              formControlName="weekFrequency"
                              type="text"
                              class="input input-bordered max-w-16 bg-white input-sm"
                            />
                            <h3 class="label font-bold text-start">
                              {{ "notification.weeks" | translate }}
                            </h3>
                          </div>
                        }
                      </div>

                      @if (rows.at(i).get("frequency")?.value !== "daily") {
                        <div class="flex flex-row items-center gap-2 my-4">
                          @for (opt of daysOpts; track opt.value) {
                            <label
                              class="form-control w-full max-w-xs cursor-pointer label"
                            >
                              <span>{{ opt.label | translate }}</span>
                              <input
                                type="checkbox"
                                class="checkbox checkbox-primary"
                                [checked]="
                                  row.get('days')?.value.includes(opt.value)
                                "
                                (change)="onDaysChange(i, opt.value, $event)"
                              />
                            </label>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
          } @empty {
            <tr>
              <td colspan="5" class="text-center">{{ "Aucune ligne" }}</td>
            </tr>
          }

          <tr>
            <td colspan="5" class="text-center">
              <a class="link link-primary" (click)="addRow()">
                {{ "notification.addLine" | translate }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <a class="link link-primary mr-4" (click)="close()">
      {{ "notification.cancel" | translate }}
    </a>
    <button class="btn btn-primary" [disabled]="form.invalid" (click)="save()">
      {{ "notification.confirmation" | translate }}
    </button>
  </mat-dialog-actions>
</div>
